const linkTemplate = [{ 0: 'salesUPC', 1: 'orderGuideUPC' }];

export default linkTemplate;
